import { render, staticRenderFns } from "./Communication.vue?vue&type=template&id=1c77231f&scoped=true"
import script from "./Communication.vue?vue&type=script&lang=js"
export * from "./Communication.vue?vue&type=script&lang=js"
import style1 from "./Communication.vue?vue&type=style&index=1&id=1c77231f&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1c77231f",
  null
  
)

export default component.exports